import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

const passwordKey = '14accb2b-30de-4de8-8516-d343c214d530';
const localStorageKeys = {
  iv: 'sgzp_iv',
  salt: 'sgzp_salt',
  main: 'sgzp_email_password',
};

@Component({
  selector: 'app-hicrea-sso-login',
  templateUrl: './hicrea-sso-login.component.html',
  styleUrls: ['../style/global.css', './hicrea-sso-login.component.css'],
})
export class HicreaSsoLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  get isMedicalUser() {
    return this.role !== 'patient';
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get isShowHeader() {
    // oemの場合はヘッダーを非表示にする
    if (this.isOem) return false;
    // dstationConfigが設定されている場合はその設定に従う
    if (this.app?.dstationConfig?.isHideLoginPageComponent?.header)
      return false;
    return true;
  }

  get isShowPageLinks() {
    // dstationConfigが設定されている場合はその設定に従う
    if (this.app?.dstationConfig?.isHideLoginPageComponent?.pageLinks)
      return false;
    return true;
  }

  get isRegisterResendable(): boolean {
    // EAJの場合は確認メール再送信させない
    if (environment.apps[this.clientId].oemConfig?.id === 'EAJ') return false;

    return true;
  }

  get isRegistable() {
    // 医療ユーザーがログインしようとしている場合は新規会員登録させない
    if (this.isMedicalUser) return false;

    // 自治体向けOEMの場合も新規会員登録させない
    if (this.isOem) return false;

    // dstationConfigが設定されている場合はその設定に従う
    if (this.app?.dstationConfig?.isHideLoginPageComponent?.registerButton)
      return false;

    return true;
  }

  get logoUrl() {
    return this.app?.oemConfig?.imgpath || '/assets/hicrea-sso/images/logo.svg';
  }

  clearEmailAddress() {
    localStorage.removeItem(localStorageKeys.main);
    localStorage.removeItem(localStorageKeys.iv);
    localStorage.removeItem(localStorageKeys.salt);
  }

  async navigateCportal(page: string) {
    window.open(
      environment.baseUri +
      '/' +
      page +
      '?client_id=' +
      environment.apps[this.clientId].hicreaSso?.cportalClientId
    );
    // location.href = environment.apps[this.clientId].appUrl;
    // location.href(['/forgot-password'], { queryParams: { client_id: 'MlKV6iDJ0SCIEcEQFfCRyIQgzUbVyaX3' } });
  }
}
